export class SubMenuStatus {
    sumMenuName: String = null;
    isVisible: Boolean = null;
    isDisplayNone: Boolean = null;
}